import _typeof from "@babel/runtime/helpers/typeof";
/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
var hexDigits = '0123456789abcdefghijklmnopqrstuvwxyz';
function toCamelCase(str) {
  var outStr = '';
  var addHump = false;
  for (var i = 0; i < str.length; i++) {
    var oldChar = str.charAt(i);
    if (!oldChar) {
      break;
    }
    if ('-_'.includes(oldChar)) {
      addHump = true;
    } else {
      if (addHump) {
        outStr += oldChar.toUpperCase();
      } else {
        outStr += oldChar.toLowerCase();
      }
      addHump = false;
    }
  }
  return outStr;
}
function uuid(len) {
  var uuids = [];
  for (var i = 0; i < len; i++) {
    uuids[i] = hexDigits.substr(Math.floor(Math.random() * 36), 1);
  }
  return uuids.join('');
}
function removeScriptTag(spinnerList) {
  var reTag = /<(?:.|\s)*?>/g;
  var str = JSON.stringify(spinnerList);
  str = str.replace(reTag, '');
  return JSON.parse(str);
}
function replaceSpecialChars(str) {
  str = str.replace(/&/g, '&amp;');
  str = str.replace(/</g, '&lt;');
  str = str.replace(/>/g, '&gt;');
  return str;
}
function digitalFillZero(number, digits) {
  if (digits <= 0) {
    throw new Error('The incoming character length limit is incorrect');
  }
  var numStr = number.toString();
  var numDigits = numStr.length;
  var concatStr = '';
  for (var i = 0; i < digits - numDigits; i++) {
    concatStr += '0';
  }
  return concatStr + numStr;
}
function stringTrim(params) {
  var type = _typeof(params);
  var result;
  switch (type) {
    case 'object':
      result = Object.assign({}, params);
      for (var key in result) {
        if (typeof result[key] === 'string') {
          result[key] = result[key].trim();
        }
        if (_typeof(result[key]) === 'object') {
          result[key] = stringTrim(result[key]);
        }
      }
      break;
    case 'string':
      result = params && params.trim();
      break;
    default:
      throw new Error('Incoming parameter exception');
  }
  return result;
}
function replaceUrlSrc(urlSrc) {
  if (urlSrc) {
    return urlSrc.replace('url:', '');
  }
  return '';
}
function removeHTMLTag(str) {
  var reg = /<\/?.+?\/?>/g;
  if (str) {
    return str.replace(reg, '');
  } else {
    return '';
  }
}
function isiOS(userAgent) {
  if (!userAgent) {
    return false;
  }
  return !!userAgent.toLowerCase().match(/(ipod|iphone)/);
}
function isAndroidPhone(userAgent) {
  if (!userAgent) {
    return false;
  }
  var ua = userAgent.toLowerCase();
  return !!ua.match(/android/) && !!ua.match(/mobile/);
}
function isPhone(userAgent) {
  if (!userAgent) {
    return false;
  }
  var ua = userAgent.toLowerCase();
  return !!ua.match(/(micromessenger|webbrowser|windows whone|blackberry|ipod|iphone|webos)/) || isAndroidPhone(userAgent);
}
function isIpadOS(userAgent) {
  if (!userAgent) {
    return false;
  }
  var ua = userAgent.toLowerCase();
  return ua.match(/(ipad)/) || /macintosh|mac os x/i.test(ua) && navigator.maxTouchPoints && navigator.maxTouchPoints > 2;
}
function isFirefox(userAgent) {
  return /firefox/.test(userAgent.toLocaleLowerCase());
}
export { toCamelCase, uuid, removeScriptTag, replaceSpecialChars, digitalFillZero, stringTrim, replaceUrlSrc, removeHTMLTag, isPhone, isiOS, isIpadOS, isAndroidPhone, isFirefox };